import { Box, Stack, useTheme } from "@mui/material";
import Status from "@/modules/common/components/ui-kit/status/status";
import ActivityDetailsText from "@/modules/lead-page/new/components/activity/activity-details-typography";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import { ZoomCallAiStatusData } from "@/modules/zoom-calls/types";

interface Props {
  aiStatus: ZoomCallAiStatusData | null;
  variant?: "compact" | "full";
}

const ZoomCallAiStatusInlineRow = ({ aiStatus, variant = "full" }: Props) => {
  const theme = useTheme();

  if (
    !aiStatus ||
    aiStatus.status !== "completed" ||
    !aiStatus.suggestedStatusName
  ) {
    return null;
  }

  const hasPreviousStatus = Boolean(aiStatus.oldStatusName);
  const changeText = hasPreviousStatus
    ? "Suggested status change from"
    : "Suggested status";

  return (
    <PermissionGuard
      permissions={[
        {
          name: PermissionsEnum.ZOOM_CALL_AI_STATUS,
          level: PermissionLevel.READ,
        },
      ]}
    >
      <Box
        sx={{
          p: "12px",
          borderRadius: "12px",
          backgroundColor: theme.nawy.colors.primitives.white[200],
        }}
      >
        <Stack
          direction="row"
          spacing={theme.nawy.spacing.xxs}
          rowGap={theme.nawy.spacing.xxs}
          flexWrap="wrap"
          alignItems="center"
        >
          {variant === "full" && (
            <>
              <ActivityDetailsText>{changeText}</ActivityDetailsText>
              {hasPreviousStatus && aiStatus.oldStatusName && (
                <>
                  <Status
                    label={aiStatus.oldStatusName}
                    bgHexColor={aiStatus.oldStatusColor || ""}
                    size="md"
                    width="auto"
                  />
                  <ActivityDetailsText>to</ActivityDetailsText>
                </>
              )}
            </>
          )}

          <Status
            label={aiStatus.suggestedStatusName}
            bgHexColor={aiStatus.suggestedStatusColor || ""}
            size="md"
            width="auto"
          />
        </Stack>
      </Box>
    </PermissionGuard>
  );
};

export default ZoomCallAiStatusInlineRow;
